import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { categories } from './categoriesData';

const Categories = ({ setCurrentPage }) => {
  const handleCategoryClick = (category) => {
    if (category.page && setCurrentPage) {
      setCurrentPage(category.page);
    }
  };

  return (
    <section id="categories" className="bg-white py-16 font-['Cairo'] lg:py-24">
      <div className="container mx-auto px-4">
        {/* العنوان الرئيسي */}
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-3xl font-bold text-gray-900 lg:text-4xl">تسوق حسب الفئة</h2>
          <p className="mx-auto max-w-2xl text-xl text-gray-600">
            اكتشف مجموعتنا الواسعة من المنتجات الصحية والطبية المصنفة بعناية لسهولة البحث
          </p>
        </div>

        {/* شبكة الفئات */}
        <div className="mb-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => handleCategoryClick(category)}
              className={`group rounded-2xl bg-white p-6 shadow-md ring-1 ring-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:ring-[#10B981]/20 ${
                category.page ? 'cursor-pointer' : 'cursor-default'
              }`}
            >
              <div className={`mb-4 w-fit rounded-2xl ${category.bgColor} p-4 transition-transform duration-300 group-hover:scale-105`}>
                <div className={category.color}>{category.icon}</div>
              </div>
              <h3 className="mb-2 text-xl font-bold text-gray-900 transition-colors group-hover:text-[#10B981]">
                {category.name}
              </h3>
              <p className="mb-3 text-sm leading-relaxed text-gray-600">{category.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-500">{category.count}</span>
                {category.page ? (
                  <ArrowLeft className="h-4 w-4 text-[#10B981] transition-transform duration-300 group-hover:-translate-x-1" />
                ) : (
                  <span className="text-xs font-medium text-gray-400">قريباً</span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* قسم العروض الخاصة */}
        <div className="rounded-2xl bg-gradient-to-l from-[#10B981] to-indigo-500 p-8 text-center text-white shadow-xl shadow-[#10B981]/10 lg:p-12">
          <div className="mx-auto max-w-3xl">
            <h3 className="mb-4 text-2xl font-bold lg:text-3xl">عروض خاصة على جميع الفئات</h3>
            <p className="mb-8 text-lg opacity-90">
              احصل على خصم يصل إلى 30% على مجموعة مختارة من المنتجات في جميع الفئات
            </p>
            <div className="flex flex-col justify-center gap-4 sm:flex-row">
              <button
                onClick={() => setCurrentPage && setCurrentPage('offers')}
                className="inline-flex items-center justify-center rounded-xl bg-white px-8 py-4 text-lg font-bold text-[#10B981] shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
              >
                تصفح العروض
              </button>
              <a
                href="#newsletter"
                className="inline-flex items-center justify-center rounded-xl border-2 border-white/80 px-8 py-4 text-lg font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-white hover:text-[#10B981]"
              >
                اشترك في النشرة
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Categories;
